var _excluded = ["className", "type", "placeholder", "disabled", "error", "small"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import deprecate from 'util-deprecate';
var TextBox = /*#__PURE__*/React.forwardRef(deprecate(function (_ref, ref) {
  var _classnames;

  var className = _ref.className,
      type = _ref.type,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled,
      error = _ref.error,
      small = _ref.small,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("input", _extends({
    ref: ref,
    className: classnames('textbox', (_classnames = {}, _defineProperty(_classnames, className, className), _defineProperty(_classnames, 'textbox--with-error', error), _defineProperty(_classnames, 'textbox--small', small), _classnames)),
    type: type,
    placeholder: placeholder,
    disabled: disabled
  }, rest));
}, '<TextBox/> from Telia Styleguide is a deprecated component. Use <TextField/> instead'));
TextBox.displayName = 'TextBox';
TextBox.defaultProps = {
  placeholder: '',
  onChange: function onChange() {}
};
TextBox.propTypes = {
  type: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  small: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func
};
export default TextBox;